import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'CSJ tabs',
    defaultMessage: 'Pestanyes CSJ',
  },
  sectionHeading: {
    id: 'CSJ tabs heading',
    defaultMessage: 'Capçalera de secció',
  },
  variant: {
    id: 'CSJ tabs variant',
    defaultMessage: 'Variant',
  },
});

export const TabsSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['section_heading', 'variant'],
    },
  ],
  properties: {
    section_heading: {
      title: intl.formatMessage(messages.sectionHeading),
      widget: 'text',
    },
    variant: {
      title: intl.formatMessage(messages.variant),
      widget: 'select',
      choices: [
        ['text', 'Text'],
        ['icon', 'Icona'],
        ['image', 'Imatge'],
      ],
      default: 'text',
    },
  },
  required: [],
});
